import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { configureStore } from '@reduxjs/toolkit';
import configSlice from './ConfigState/ConfigState.slice';
import userAddressSlice from './UserAddressState/UserAddressState.slice';
import { listenerMiddleware } from './listeners';
export var createStore = function createStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = configureStore({
    reducer: _defineProperty(_defineProperty({}, configSlice.name, configSlice.reducer), userAddressSlice.name, userAddressSlice.reducer),
    middleware: function middleware(gDM) {
      return gDM().prepend(listenerMiddleware.middleware);
    },
    preloadedState: initialState
  });
  return store;
};
var store = createStore();
export default store;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/redux/store.js
// module id = 4417
// module chunks = 11